import React, { useEffect, useState, useRef } from 'react'
import Flexbox from '../Flexbox'
import styled from 'styled-components'
import { H2, H4, List, ListItem, Icon, Text, ComponentWrapper } from './Section.styles'


import ButtonHome from '../ButtonHome'
import FadeIn from '../FadeIn'

const P = styled.p`
line-height: ${({ lineHeight }) => lineHeight};
/* font-size: 30px; */
`;

const Section = ({ headingFontSize, headingFontSizeMobile, listContentTextProps, listClassName, itemProps, subTextStyling, button, subtext = [], title, maxWidth = "700px", listContent, justifyContent, flexGrow, flexWrap, itemsPerRow = 2, itemsPerRowMobile = 1, listContainerProps, listItemMargin = 10, gap = "20px", listItemInnerGap = "10px", listParagraphColor, id, props }) => {
    console.log("justifyContent", justifyContent)
    const flexBasis = useRef(listContent.length)
    return (
        <Flexbox id={id} column width="100%" alignText="center" padding="50px" mobilePadding="50px 5%" {...props}>
            <Flexbox column maxWidth={maxWidth} >
                <FadeIn>
                    <H2 >{title}</H2>
                </FadeIn>

                {subtext.filter(it => it.position === 'start').map((it, index) =>
                    <FadeIn {...subTextStyling}>
                        <Text key={index} {...subTextStyling} {...it}>{it.text}</Text>
                    </FadeIn>
                )}

                <List gap={listItemMargin + 'px'}
                    col={`repeat(${itemsPerRow},1fr)`}
                    mobileCol={`repeat(${itemsPerRowMobile},1fr)`}
                    justifyContent={justifyContent} wrap={flexWrap} className={listClassName} maxWidth={maxWidth} {...listContainerProps}>
                    {
                        listContent.map((it, idx) =>
                            <ListItem key={idx} flexGrow={flexGrow}
                                flexBasis={`calc(${(100 / itemsPerRow) + '%'} - ${(itemsPerRow) * listItemMargin}px)`}

                                gap={listItemInnerGap} listParagraphColor={listParagraphColor} {...itemProps} {...it['props']}>
                                <FadeIn relative column alignItems="center" threshold={0.3}>
                                    {it.img && <Icon src={it.img} />}
                                    {it['useComponent'] && <ComponentWrapper>{it['useComponent']}</ComponentWrapper>}
                                    {it['heading'] && <H4 fontSize={headingFontSize} headingFontSizeMobile={headingFontSizeMobile}>{it['heading']}</H4>}
                                    {(it['text'] && typeof (it['text'] === 'string')) && <P style={{ color: it['textColor'] }} {...listContentTextProps}>{it.text}</P>}
                                    {(it['text'] && Array.isArray(it['text'])) && it['text'].map(txt => <P style={{ color: it['textColor'] }} {...listContentTextProps}>{txt}</P>)}
                                </FadeIn>
                            </ListItem>
                        )
                    }
                </List>
                {subtext.filter(it => it.position === 'end').map((it, index) =>
                    <FadeIn  {...subTextStyling}>
                        <Text key={index}>{it.text}</Text>
                    </FadeIn>
                )}
                {button && <ButtonHome text={button['text']} width="200px" {...button} />}
            </Flexbox>
            {/* <MatchIconAnimated /> */}
        </Flexbox >
    )
}

export default Section